"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FlexLayout = _interopRequireDefault(require("./FlexLayout"));

var _FlexItem = _interopRequireDefault(require("./FlexItem"));

var _MenuIcon = _interopRequireDefault(require("../Icons/MenuIcon"));

var _NutanixLogoIcon = _interopRequireDefault(require("../Icons/NutanixLogoIcon"));

var _Separator = _interopRequireDefault(require("../Separator/Separator"));

var _VerticalSeparator = _interopRequireDefault(require("../Separator/VerticalSeparator"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * NavBarLayout provides a layout for the common Prism navigation bar layout.
 */
var NavBarLayout =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavBarLayout, _React$Component);

  function NavBarLayout() {
    _classCallCheck(this, NavBarLayout);

    return _possibleConstructorReturn(this, _getPrototypeOf(NavBarLayout).apply(this, arguments));
  }

  _createClass(NavBarLayout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          accountActions = _this$props.accountActions,
          accountInfo = _this$props.accountInfo,
          className = _this$props.className,
          eventsTasksInfo = _this$props.eventsTasksInfo,
          layout = _this$props.layout,
          logoIcon = _this$props.logoIcon,
          menuIcon = _this$props.menuIcon,
          menuItems = _this$props.menuItems,
          searchInput = _this$props.searchInput,
          title = _this$props.title,
          props = _objectWithoutProperties(_this$props, ["accountActions", "accountInfo", "className", "eventsTasksInfo", "layout", "logoIcon", "menuIcon", "menuItems", "searchInput", "title"]); // Assume logo position is set to "center" by default.
      // Set left side elements.


      var leftElements = [_react.default.createElement(_FlexLayout.default, {
        key: "menuIcon",
        className: "menu-icon left-icon",
        justifyContent: "center",
        alignItems: "center"
      }, menuIcon), _react.default.createElement(_FlexItem.default, {
        key: "searchInput",
        className: "search",
        flexGrow: "1"
      }, searchInput)]; // Set center elements.

      var centerElements = _react.default.createElement(_FlexLayout.default, {
        className: "logo-icon center-icon",
        justifyContent: "center",
        alignItems: "center"
      }, _react.default.createElement(_FlexItem.default, null, logoIcon)); // Set right side elements.


      var rightElements = [_react.default.createElement(_FlexLayout.default, {
        key: "eventsTasksInfo",
        className: "events-tasks",
        alignItems: "center"
      }, eventsTasksInfo), _react.default.createElement(_FlexLayout.default, {
        key: "accountInfo",
        className: "account-info"
      }, accountInfo)]; // If logo position is set to "left", change to left-aligned layout.

      if (layout === NavBarLayout.LAYOUTS.LEFT) {
        var menu = null;

        if (menuItems) {
          // Render menu items as a horizontal list by default.
          var menuItemNodes = (0, _map2.default)(menuItems, function (menuItem, index) {
            return _react.default.createElement(_FlexLayout.default, {
              key: menuItem.key,
              className: "menu-item"
            }, menuItem.label);
          });
          menu = _react.default.createElement(_FlexLayout.default, {
            className: "horizontal-menu"
          }, menuItemNodes);
        } // Set left side elements.


        leftElements = [_react.default.createElement(_FlexLayout.default, {
          key: "logoIcon",
          className: "logo-icon left-icon",
          justifyContent: "center",
          alignItems: "center"
        }, _react.default.createElement(_FlexItem.default, null, logoIcon)), _react.default.createElement(_Separator.default, {
          key: "separator",
          separator: _react.default.createElement(_VerticalSeparator.default, {
            theme: "dark"
          }),
          spacing: "spacing-20px"
        }, title ? _react.default.createElement(_FlexLayout.default, {
          className: "app-title"
        }, title) : null, menu ? _react.default.createElement(_FlexLayout.default, {
          className: "menu"
        }, menu) : null, eventsTasksInfo ? _react.default.createElement(_FlexLayout.default, {
          className: "events-tasks"
        }, eventsTasksInfo) : null)]; // Set center elements.

        centerElements = null; // Set right elements.

        rightElements = _react.default.createElement(_Separator.default, {
          separator: _react.default.createElement(_VerticalSeparator.default, {
            theme: "dark"
          }),
          spacing: "spacing-20px"
        }, accountActions ? _react.default.createElement(_FlexLayout.default, {
          className: "account-actions"
        }, accountActions) : null, _react.default.createElement(_FlexLayout.default, {
          className: "account-info"
        }, accountInfo));
      }

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)("".concat(clsPrfx, " ").concat(clsPrfx, "-nav-bar-layout"), className),
        itemSpacing: "80px",
        justifyContent: "space-between",
        alignItems: "center"
      }, props), _react.default.createElement(_FlexLayout.default, {
        className: "left-of-center",
        justifyContent: "flex-start",
        alignItems: "center"
      }, leftElements), centerElements, _react.default.createElement(_FlexLayout.default, {
        className: "right-of-center",
        justifyContent: "flex-end",
        alignItems: "center"
      }, rightElements));
    }
  }]);

  return NavBarLayout;
}(_react.default.Component);

exports.default = NavBarLayout;
NavBarLayout.LAYOUTS = {
  CENTER: 'center',
  LEFT: 'left'
};
NavBarLayout.defaultProps = {
  logoIcon: _react.default.createElement(_NutanixLogoIcon.default, {
    color: "gray-1"
  }),
  layout: NavBarLayout.LAYOUTS.CENTER,
  menuIcon: _react.default.createElement(_MenuIcon.default, {
    color: "dark"
  })
};
NavBarLayout.propTypes = {
  /**
   * Cell reserved for displaying account action icons.
   * Position depends on layout value.
   */
  accountActions: _propTypes.default.node,

  /**
   * Cell reserved for displaying account info.
   * Always the right-most cell.
   */
  accountInfo: _propTypes.default.node,

  /**
   * Additional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * Cell reserved for displaying events/alert/tasks summaries.
   * Position depends on layout value.
   */
  eventsTasksInfo: _propTypes.default.node,

  /**
   * Controls the order of the cells.
   * See NavBarLayout.LAYOUTS for options.
   * See http://nutanix.design/2.0/#Layouts_Headers for visual differences
   * between each layout.
   */
  layout: _propTypes.default.string.isRequired,

  /**
   * Cell reserved for displaying the app's logo.
   * Position depends on layout value.
   */
  logoIcon: _propTypes.default.node.isRequired,

  /**
   * Cell reserved for the menu icon.
   * Always the left-most cell (only visible when layout is "center").
   */
  menuIcon: _propTypes.default.node,

  /**
   * List of navigation menu items.
   */
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    label: _propTypes.default.node
  })),

  /**
   * Cell reserved for the search input.
   * Always the 2nd cell from the left (only visible when layout is "center").
   */
  searchInput: _propTypes.default.node,

  /**
   * Cell reserved for displaying the app's title.
   * Always the 2nd cell from the left (only visible when layout is "left").
   */
  title: _propTypes.default.node
};